import { Result } from "./etplayer";
import data_de from "./locale/de.json";
import data_it from "./locale/it.json";

var _locales = {
	'en': { '_lang': 'en'},
	'de': flattenRec(data_de),
	'it': flattenRec(data_it),
} as {[lang: string]: Locale}

type Locale = { [key:string]: string }

var _active: string|undefined

// _applyLocale -- finds DOM nodes with 'data-tr' and applies the given language to them
// TODO this only works for $(...).text(), add support for other attributes (like placeholder, ...)
function _apply(lang: string, $rootElement?: JQuery) {
	if (!_locales || !_locales[lang]) {
		console.error("tried to apply locale that hasn't been loaded yet");
		return;
	}
	_active = lang;

	$('[data-tr]', $rootElement).each(function(_n, elem) {
		var key = elem.dataset['tr'];
		if (key==undefined) return;

		var locale = _locales[lang];
		if (key in locale) {
			var $elem = $(elem);
			if (!(key in _locales['en'])) {
				_locales['en'][key] = $elem.text();
			}
			$elem.text(locale[key]);
		}
		else if (locale._lang !== 'en') {
			if (window.console) console.error('i18n failed for key ', elem.dataset['tr'], elem);
		}
	});
}

export function detectLanguage() {
	let rc = null;
	for (let i in navigator.languages) {
		let code = navigator.languages[i].toLowerCase().replace('_', '-').split('-')[0]; // we only care about the first part (e.g. 'en' for 'en_US' or 'en-US')
		if (code in _locales) {
			rc = code;
			break;
		}
	}

	if (rc != null) console.log("detected language: ", rc);
	else {
		console.log("no matching language found, defaulting to English");
		rc = 'en';
	}
	return rc;
}

// applies the given locale (if lang is unset, it'll use document.localStorage.getItem('locale') or default to 'de')
export function set(lang?: string, $rootElement?: JQuery<HTMLElement>) {
	if (lang == undefined) lang = _active;
	if (lang == undefined) lang = detectLanguage();
	_active = lang
	_apply(lang, $rootElement);
}

function flattenRec(data: any, result: Locale = {}, path: string[] = []) {
	for (var key in data) {
		var value = data[key];
		var childPath = path.concat([key]);
		if (value.constructor == Object) { // test if it's a dict
			flattenRec(value, result, childPath);
		} else if ($.isArray(value)) {
			flattenRec(value, result, childPath);
		}
		else result[childPath.join('.')] = value;
	}

	return result;
}